import React from 'react';

type BoolInputProps = {
	value: boolean | null | undefined;
	onChange: (value: boolean | null) => void;
	style?: React.CSSProperties;
	nullable?: boolean;
	plain?: boolean;
};

const BoolInput = ({ value, onChange, style = {}, nullable = false, plain = false }: BoolInputProps) => {
	const noChecked = nullable ? (!value && value !== null && value !== undefined) : !value;
	const yesChecked = !!value;

	if (plain === false) {
		return (
			<div style={{ ...{ display: 'flex', flexDirection: 'row' }, ...style }}>

				<span
					style={{
						display: 'flex', flexDirection: 'row', alignItems: 'center'
					}}
				>
					<label>
						No
						<input
							type="radio"
							checked={noChecked}
							onChange={() => {
								onChange && onChange(false);
							}}
						/>
					</label>
				</span>
				&nbsp;&nbsp;
				<span
					style={{
						display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '10px'
					}}
				>
					<label>
						Yes
						<input type="radio" checked={yesChecked} onChange={() => onChange && onChange(true)} />
					</label>
				</span>
				
			</div>
		);
	}
	
	return (
		<div>
			<div className="inline-group">
				<div half-width="true">
					<label>
						No
						<div half-width="true">
							<input
								type="radio"
								checked={noChecked}
								onChange={() => {
									onChange && onChange(false);
								}}
							/>
						</div>
					</label>
				</div>
			</div>
			<div className="inline-group">
					
				<div half-width="true">
					<label>
						Yes
						<div half-width="true">
							<input type="radio" checked={yesChecked} onChange={() => onChange && onChange(true)} />
						</div>
					</label>
				</div>
			</div>
		</div>
	);
};

export default BoolInput;
